import React from 'react';
import { selectUlogovan, selectRole, selectUsername, selectRouteSimple, selectUser } from '../redux/selectors';
import { connect } from 'react-redux';
import { actionRoute } from "../redux/actions";
import { urlLib } from '../utils/url-lib';
// import RenderIfTrue from './RenderIfTrue';
import SidebarMenu from './SidebarMenu';
import { app_build_version_id } from '..';


const Sidebar = (props) => {
  const dispatch = props.dispatch;
  let active = props.routeSimple.route;
  let ulogovan = props.ulogovan;
  let role = props.role;
  let username = props.username;
  let user = props.user;
  let modeAdminPanel = false;
  if (props.modeAdminPanel === true) {
    modeAdminPanel = props.modeAdminPanel;
  }

  let is_guest = true;

  let cl = 'layout-sidebar layout-sidebar-bg';

  if (ulogovan) {
    // ako smo ulogovani
    is_guest = false;
    cl += ' mode-loggedin';
    if (role === "ADMIN") {
      //
    } else {
      //
    }
  } else {
    // ako nismo ulogovani
    cl += ' mode-guest';
  }

  let clicked = (what) => {
    return () => {
      dispatch(actionRoute(what))
    };
  }

  const logoSrc = urlLib.terSlika('Termovent-logo-01.svg');

  let jsxAvatarPlaceholder = (
    <div className="avatar-widget avatar-placeholder"></div>
  );

  let displayRole = role;
  let jsxAvatar = jsxAvatarPlaceholder;
  let jsxNickname = null;

  if (role === 'DEV') {
    is_guest = false;
    let jsxAvatarDev = (
      <div className="avatar-widget user-is-dev">
        <span>DEV</span>
      </div>
    );
    jsxAvatar = jsxAvatarDev;
    /*
  } else if (role === 'ADMIN') {
    is_guest = false;
    let jsxAvatarAdmin = (
      <div className="avatar-widget user-is-admin">
        <span>ADM</span>
      </div>
    );
    jsxAvatar = jsxAvatarAdmin;
    */
  } else if (role === 'TESTER') {
    is_guest = false;
    let jsxAvatarOther = jsxAvatarPlaceholder;
    if (user && typeof user.avatar_initials === 'string' && user.avatar_initials !== '') {
      jsxAvatarOther = (
        <div className={"avatar-widget user-is-other" + (user.avatar_initials.length > 2 ? "" : " avatar-widget--two-characters-initial")}>
          <span>{user.avatar_initials}</span>
        </div>
      );
    }
    jsxAvatar = jsxAvatarOther;
  } else if (role === 'ING') {
    is_guest = false;
    let jsxAvatarIng = (
      <div className="avatar-widget user-is-regular">
        <span>ING</span>
      </div>
    );
    jsxAvatar = jsxAvatarIng;
  } else if (role === 'USER') {
    is_guest = false;
    let jsxAvatarUser = jsxAvatarPlaceholder;
    if (user && typeof user.avatar_initials === 'string' && user.avatar_initials !== '') {
      jsxAvatarUser = (
        <div className={"avatar-widget user-is-regular" + (user.avatar_initials.length > 2 ? "" : " avatar-widget--two-characters-initial")}>
          <span>{user.avatar_initials}</span>
        </div>
      );
    }
    jsxAvatar = jsxAvatarUser;
  } else {
    // else avatar placeholder
    is_guest = false;
    let clAvatar = " user-is-regular";
    if (role === 'ADMIN') {
      clAvatar = " user-is-admin";
    }
    let jsxAvatarUser = jsxAvatarPlaceholder;
    if (user && typeof user.avatar_initials === 'string' && user.avatar_initials !== '') {
      jsxAvatarUser = (
        <div className={"avatar-widget" + clAvatar + (user.avatar_initials.length > 2 ? "" : " avatar-widget--two-characters-initial")}>
          <span>{user.avatar_initials}</span>
        </div>
      );
    }
    jsxAvatar = jsxAvatarUser;
  }

  if (is_guest === false) {
    jsxNickname = (
      <div className="nickname clickable" onClick={clicked('HOME')}><abbr title={"username: " + (username)}><span>{username}</span></abbr></div>
    );
  } else {
    displayRole = 'GUEST';
  }

  return (
    <div className={cl}>
      <div className="fix-header-push"></div>
      <div className="sidebar-header uu-display-none">
        <div className="pad">
          <span className="admin-only text-red">Admin</span>
          <span className="guest-only text-green">Guest</span>
        </div>
      </div>
      <div className="pad">

        {
          modeAdminPanel === false ? (
            <div className="logo clickable" onClick={clicked('HOME')}>
              <img className="logo-img" alt="Termovent logo" src={logoSrc} />
              <div className="subtitle">{props.app_subtitle}</div>
              <div className="subtitle-version">Version: {app_build_version_id}</div>
            </div>
          ) : (
            <div className="logo">
              <div className="subtitle-version">Version: {app_build_version_id}</div>
            </div>
          )
        }

        <h3 className="uu-display-none">Korisnik</h3>

        <div className="user-group">
          <div className="avatar-group">
            <div className="avatar clickable" onClick={clicked('HOME')}>
              {jsxAvatar}
            </div>
            <div className="avatar-group__tail">
              {jsxNickname}
              <div className="display-role">Uloga: <span>{displayRole}</span></div>
            </div>
          </div>
        </div>

        <SidebarMenu modeAdminPanel={modeAdminPanel} />
      </div>
      <a href="#" className="btn-scroll-to-top"><i className="fa fa-angle-double-up"></i></a>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    routeSimple: selectRouteSimple(state),
    ulogovan: selectUlogovan(state),
    role: selectRole(state),
    username: selectUsername(state),
    user: selectUser(state),
  };
};
export default connect(mapStateToProps)(Sidebar);
